export function convertBase64ToBlob(base64: string) {

	const decodedData = window.atob(base64);

	const uInt8Array = new Uint8Array(decodedData.length);

	for (let i = 0; i < decodedData.length; ++i) {
		uInt8Array[i] = decodedData.charCodeAt(i);
	}

	return new Blob([uInt8Array], { type: 'pdf' });
}

export function formatMoney(amount: number | undefined) {

	return amount || amount === 0 ? amount.toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	}) : '';
}

export function validateEmail(value: string) {
	var input = document.createElement('input');

	input.type = 'email';
	input.required = true;
	input.value = value;

	return typeof input.checkValidity === 'function' ? input.checkValidity() : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function formatPhoneNumber(phoneNumber: string) {
	// Remove country code
	phoneNumber = phoneNumber.replace(/\+\d\s?/g, '');

	// Remove brackets, spaces and dashes
	phoneNumber = phoneNumber.replace(/[() -]/g, '');

	// Add dash between phone number sections
	phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

	return phoneNumber;
}